export interface DescribedImage {
  resource: string;
  provider: string;
  description: string;
}

export interface Download {
  name?: string;
  file_name?: string;
  file_type?: string;
  path: string;
  size?: string;
}

export interface Video {
  provider: string;
  resource: string;
}

export interface Hall {
  id: string;
  name: string;
  fair_id: string;
  booths: Booth[];
}

export interface Booth {
  name: string;
  coordinates?: string;
  area?: BoothArea;
}

export interface BoothArea {
  width?: number;
  depth?: number;
  total?: number;
}

export interface Brand {
  name: string;
  logo: DescribedImage;
}

export interface Topic {
  id: string;
  name: string;
  description: string;
}

export interface Profession {
  name: string;
  id: string;
  topics?: Topic[];
}

export interface Link {
  text: string;
  path: string;
}

export interface ProductGroup {
  id: string;
  external_id: string;
  name: string;
  root_path: string[];
}

export interface SocialMedia {
  linked_in?: string;
  xing?: string;
  instagram?: string;
  facebook?: string;
  twitter?: string;
  tiktok?: string;
  pinterest?: string;
  youtube?: string;
}

export interface Contact {
  phone?: string;
  email?: string;
  fax?: string;
}

export interface Address {
  street?: string;
  house_number?: string;
  zip_code?: string;
  city?: string;
  country?: string;
}

export type AddressPart = 'street' | 'house_number' | 'zip_code' | 'city' | 'country';

export enum EntityType {
  product = 'PRODUCT',
  exhibitor = 'EXHIBITOR',
  event = 'EVENT',
  post = 'POST',
  brand = 'BRAND',
}
